document.documentElement.classList.add('tc-js');

(function () {
  'use strict';

  /* ---------- Buy now: add to cart then go straight to checkout ---------- */
  function setButtonLoading(form, loading) {
    var btn = form.querySelector('[data-tc-submit]');
    if (!btn) return;
    btn.disabled = loading;
    if (loading) {
      btn.dataset.originalText = btn.dataset.originalText || btn.textContent;
      btn.textContent = btn.dataset.loadingText || 'Agregando...';
    } else if (btn.dataset.originalText) {
      btn.textContent = btn.dataset.originalText;
    }
  }

  function showFormError(form) {
    var err = form.querySelector('[data-tc-error]');
    if (err) err.classList.add('is-visible');
  }

  function handleBuyForm(form) {
    form.addEventListener('submit', function (evt) {
      evt.preventDefault();
      var idInput = form.querySelector('input[name="id"]');
      if (!idInput || !idInput.value) return;

      var err = form.querySelector('[data-tc-error]');
      if (err) err.classList.remove('is-visible');
      setButtonLoading(form, true);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: idInput.value, quantity: 1 }] })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('add_to_cart_failed');
          return res.json();
        })
        .then(function () {
          window.location.href = '/checkout';
        })
        .catch(function () {
          setButtonLoading(form, false);
          showFormError(form);
        });
    });
  }

  document.querySelectorAll('[data-tc-buy-form]').forEach(handleBuyForm);

  /* ---------- Image carousel: swipeable, dots reflect scroll position ---------- */
  document.querySelectorAll('[data-tc-carousel]').forEach(function (carousel) {
    var track = carousel.querySelector('.tc-carousel__track');
    var slides = carousel.querySelectorAll('.tc-carousel__slide');
    var dots = carousel.querySelectorAll('.tc-carousel__dot');
    if (!track || !slides.length || !dots.length) return;

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        slides[i].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      });
    });

    // Some browsers restore a scrollable element's previous scroll offset on
    // reload / back-forward navigation, which can open this carousel on a
    // slide other than the first. When present, this attribute pins it back
    // to slide 1 on every load — it's only rendered for Curlia's hero.
    if (carousel.hasAttribute('data-tc-pin-first-slide')) {
      var pinToFirstSlide = function () {
        track.scrollLeft = 0;
      };
      pinToFirstSlide();
      window.addEventListener('pageshow', function (evt) {
        if (evt.persisted) pinToFirstSlide();
      });
    }

    if ('IntersectionObserver' in window) {
      var dotObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var index = Array.prototype.indexOf.call(slides, entry.target);
            dots.forEach(function (d, i) {
              d.classList.toggle('is-active', i === index);
            });
          });
        },
        { root: track, threshold: 0.6 }
      );
      slides.forEach(function (slide) {
        dotObserver.observe(slide);
      });
    }
  });

  /* ---------- Mini review carousel: auto-loop, pauses while the user swipes ---------- */
  document.querySelectorAll('[data-tc-mini-reviews]').forEach(function (root) {
    var track = root.querySelector('.tc-mini-reviews__track');
    var cards = root.querySelectorAll('.tc-mini-review');
    if (!track || cards.length < 2) return;

    var index = 0;
    var resumeTimer = null;
    var autoTimer = null;

    function goTo(i) {
      index = (i + cards.length) % cards.length;
      cards[index].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
    }
    function startAuto() {
      stopAuto();
      autoTimer = window.setInterval(function () {
        goTo(index + 1);
      }, 3500);
    }
    function stopAuto() {
      if (autoTimer) window.clearInterval(autoTimer);
    }
    function pauseThenResume() {
      stopAuto();
      if (resumeTimer) window.clearTimeout(resumeTimer);
      resumeTimer = window.setTimeout(startAuto, 6000);
    }

    track.addEventListener('touchstart', pauseThenResume, { passive: true });
    track.addEventListener('pointerdown', pauseThenResume);

    if ('IntersectionObserver' in window) {
      var visibilityObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) startAuto();
            else stopAuto();
          });
        },
        { threshold: 0.3 }
      );
      visibilityObserver.observe(root);
    } else {
      startAuto();
    }
  });

  /* ---------- Bundle / variant picker ---------- */
  document.querySelectorAll('[data-tc-bundle-picker]').forEach(function (root) {
    var options = root.querySelectorAll('[data-tc-variant-option]');
    var form = root.querySelector('[data-tc-buy-form]');
    var hiddenInput = form ? form.querySelector('input[name="id"]') : null;
    var priceEl = root.querySelector('[data-tc-selected-price]');
    var compareEl = root.querySelector('[data-tc-selected-compare]');

    options.forEach(function (opt) {
      opt.addEventListener('click', function () {
        options.forEach(function (o) {
          o.classList.remove('is-selected');
          o.setAttribute('aria-checked', 'false');
        });
        opt.classList.add('is-selected');
        opt.setAttribute('aria-checked', 'true');
        if (hiddenInput) hiddenInput.value = opt.dataset.variantId;
        if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
        if (compareEl) compareEl.textContent = opt.dataset.compare || '';
      });
    });
  });

  /* ---------- Lazy-load + lazy-autoplay video: nothing downloads until the
     element is near the viewport, then it plays once and keeps looping.
     These are small thumbnail-sized videos laid out in a horizontally
     scrollable row (.tc-video-carousel__track, overflow-x), so on narrow
     screens items 2/3 are often only partially visible and never reach 50%
     — a stricter threshold used to pause() them right after they started,
     fighting any autoplay attempt. Fixed to start at the first sliver of
     visibility and never pause again. ---------- */
  var lazyVideos = document.querySelectorAll('[data-tc-lazy-video]');
  if (lazyVideos.length) {
    if ('IntersectionObserver' in window) {
      // Separate observer just to trigger the download once, slightly before
      // the video is on screen (rootMargin), so it's ready by the time the
      // observer below asks it to play.
      var lazyLoadObserver = new IntersectionObserver(
        function (entries, observer) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var video = entry.target;
            if (video.dataset.src && !video.src) {
              video.src = video.dataset.src;
            }
            observer.unobserve(video);
          });
        },
        { rootMargin: '200px 0px' }
      );
      lazyVideos.forEach(function (video) {
        lazyLoadObserver.observe(video);
      });

      var lazyVideoObserver = new IntersectionObserver(
        function (entries, observer) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var video = entry.target;
            if (video.dataset.src && !video.src) video.src = video.dataset.src;
            video.muted = true;
            video.play().catch(function () {});
            observer.unobserve(video);
          });
        },
        { threshold: 0 }
      );
      lazyVideos.forEach(function (video) {
        lazyVideoObserver.observe(video);
      });
    } else {
      lazyVideos.forEach(function (video) {
        if (video.dataset.src && !video.src) video.src = video.dataset.src;
        video.play().catch(function () {});
      });
    }
  }

  /* ---------- Force-autoplay fallback: some mobile/in-app browsers (e.g.
     Meta's in-app browser) throttle native autoplay for video below the
     fold even when muted. These videos already carry the native
     autoplay/muted/loop/playsinline attributes; this just retries .play()
     whenever the element enters the viewport and on first user interaction,
     as a safety net on top of the native attributes — never touches other
     <video> elements (e.g. the click-to-play-with-audio ones), only
     [data-tc-force-autoplay]. ---------- */
  var forceAutoplayVideos = document.querySelectorAll('[data-tc-force-autoplay]');
  if (forceAutoplayVideos.length) {
    var tryPlayAll = function () {
      forceAutoplayVideos.forEach(function (video) {
        video.muted = true;
        video.play().catch(function () {});
      });
    };

    tryPlayAll();

    if ('IntersectionObserver' in window) {
      var forceAutoplayObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.muted = true;
              entry.target.play().catch(function () {});
            }
          });
        },
        { threshold: 0.25 }
      );
      forceAutoplayVideos.forEach(function (video) {
        forceAutoplayObserver.observe(video);
      });
    }

    ['touchstart', 'click', 'scroll'].forEach(function (evt) {
      document.addEventListener(evt, tryPlayAll, { once: true, passive: true });
    });
  }

  /* ---------- SkinPure hero: force-start videos that already carry the native
     autoplay/muted/loop/playsinline attributes but stay paused on some
     browsers until a JS-driven .play() call. Runs once the DOM is ready.
     totalco-hero.liquid is shared across products (SkinPure, AuraC,
     AuraGlow...), so this is scoped to product.skinpure specifically via the
     native data-template attribute — never touches Curlia (separate
     curlia-hero section) or any other product's hero. Click-to-play videos
     with visible controls are excluded. ---------- */
  function tcPlayHeroVideos() {
    document.querySelectorAll('main[data-template="product.skinpure"] [data-tc-hero] video:not([controls])').forEach(function (video) {
      if (video.dataset.src && !video.src) video.src = video.dataset.src;
      video.muted = true;
      video.autoplay = true;
      video.loop = true;
      video.playsInline = true;
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tcPlayHeroVideos);
  } else {
    tcPlayHeroVideos();
  }

  /* ---------- Reviews: "Ver más reseñas" ---------- */
  document.querySelectorAll('[data-tc-reviews-more]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var grid = btn.parentElement.querySelector('[data-tc-reviews]') || document.querySelector('[data-tc-reviews]');
      if (!grid) return;
      grid.querySelectorAll('.tc-reviews__card--hidden').forEach(function (card) {
        card.classList.remove('tc-reviews__card--hidden');
      });
      btn.remove();
    });
  });

  /* ---------- Sticky mobile CTA ---------- */
  var stickyBar = document.querySelector('[data-tc-sticky-cta]');
  var heroAnchor = document.querySelector('[data-tc-hero]');
  if (stickyBar && heroAnchor && 'IntersectionObserver' in window) {
    var stickyObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      },
      { threshold: 0 }
    );
    stickyObserver.observe(heroAnchor);
  }

  /* ---------- Scroll fade-in ---------- */
  if ('IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('tc-in-view');
            revealObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
    document.querySelectorAll('.tc-fade-in').forEach(function (el) {
      revealObserver.observe(el);
    });
  } else {
    document.querySelectorAll('.tc-fade-in').forEach(function (el) {
      el.classList.add('tc-in-view');
    });
  }
})();

